import { NgModule, ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
// import { AuthGuard } from '../common/guard/index';

@NgModule({
    imports: [
        RouterModule.forChild([{
            path: 'home',
            component: HomeComponent,
            children: [
                { path: '', redirectTo: 'crm', pathMatch: 'full' },             
                { path: 'crm', loadChildren: 'app/crm/crm.module#CRMModule' },
                { path: 'customer', loadChildren: 'app/customer/customer.module#CustomerModule' },
                { path: 'affiliate', loadChildren: 'app/affiliate/affiliate.module#AffiliateModule' },
            ]
        }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class HomeRoutingModule {
    constructor() {

    }
}



// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/home/home-routing.module.ts